// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import { connectAuthEmulator, getAuth } from "firebase/auth";
import { connectFirestoreEmulator, getFirestore } from "firebase/firestore";
import { connectFunctionsEmulator, getFunctions } from "firebase/functions";
import { connectStorageEmulator, getStorage } from "firebase/storage";

import { Environment, getEnvironment } from "@/utils/environments";

// Your web app's Firebase configuration
// For Firebase JS SDK v7.20.0 and later, measurementId is optional

const PRODPortalFirebaseConfig = {
  apiKey: "AIzaSyA1AhBUNAmUqoLrAhXQmOtcwZlK94YkmRY",
  authDomain: "aigency-portal.firebaseapp.com",
  projectId: "aigency-portal",
  storageBucket: "aigency-portal.appspot.com",
  messagingSenderId: "354199154851",
  appId: "1:354199154851:web:4f602b1f98ba2c5624cf16",
  measurementId: "G-9M32SQTXD6",
};

const _STAGINGPortalFirebaseConfig = {
  apiKey: "AIzaSyASYPfJ41Kew8l4VR2oNnpUviDJn2hTOZE",
  authDomain: "aigency-portal-staging.firebaseapp.com",
  projectId: "aigency-portal-staging",
  storageBucket: "aigency-portal-staging.firebasestorage.app",
  messagingSenderId: "78552260966",
  appId: "1:78552260966:web:f3d98037321d00d8fb28a7",
  measurementId: "G-5X3VK51J8V",
};

const portalFirebaseConfig =
  getEnvironment() === Environment.PRODUCTION
    ? PRODPortalFirebaseConfig
    : getEnvironment() === Environment.STAGING
      ? _STAGINGPortalFirebaseConfig
      : PRODPortalFirebaseConfig; // Use prod config in local - emulators will override endpoints

// Initialize Firebase
const app = initializeApp(portalFirebaseConfig);
// const analytics = getAnalytics(app);

export const auth = getAuth(app);
export const db = getFirestore(app);
// If you need to use getFunctions, import it separately and use it here
export const functions = getFunctions();
export const storage = getStorage(app);

// PR-preview function isolation (mirrors aigency-agent-generic). The
// preview-deploy workflow redeploys any callable whose backend code changed in
// the PR under a `<name>_pr_<N>` alias so it can't clobber the shared prod
// function. The workflow injects the PR number + the comma-separated list of
// isolated names into this build via Vite `define` (see vite.config.ts);
// `prCallableName` rewrites those callable names at runtime so the preview
// frontend hits the PR-specific copy while unchanged callables keep hitting
// their real (prod) names. Both globals are empty strings in non-preview builds.
const PR_NUMBER = __PR_NUMBER__;
const PR_ISOLATED_FUNCTIONS = __PR_ISOLATED_FUNCTIONS__
  .split(",")
  .map((name) => name.trim())
  .filter(Boolean);

export function prCallableName(name: string): string {
  if (!PR_NUMBER || !PR_ISOLATED_FUNCTIONS.includes(name)) return name;
  return `${name}_pr_${PR_NUMBER}`;
}

// Region for HTTP (onRequest) functions — getFunctions() also defaults here.
const FUNCTIONS_REGION = "us-central1";

/**
 * Absolute URL for a raw HTTP (onRequest) function. Callables go through the SDK's
 * httpsCallable, but an onRequest endpoint (e.g. the streaming CSV export) needs a
 * URL we build ourselves: the functions emulator in LOCAL, the deployed function
 * otherwise. PR-preview isolation is applied via prCallableName so a preview build
 * hits its own `<name>_pr_<N>` copy.
 */
export function functionHttpUrl(name: string): string {
  const resolved = prCallableName(name);
  const { projectId } = portalFirebaseConfig;
  if (getEnvironment() === Environment.LOCAL) {
    return `http://localhost:5002/${projectId}/${FUNCTIONS_REGION}/${resolved}`;
  }
  return `https://${FUNCTIONS_REGION}-${projectId}.cloudfunctions.net/${resolved}`;
}

export default app;

const apiFirebaseConfig = {
  apiKey: "AIzaSyDhof-3yQqms7q93F-3cpaqxnAlWchR62k",
  authDomain: "aigency-api.firebaseapp.com",
  projectId: "aigency-api",
  storageBucket: "aigency-api.appspot.com",
  messagingSenderId: "520549900892",
  appId: "1:520549900892:web:b13a8d85e1fc902f4bfc99",
  measurementId: "G-X01T4TFZSN",
};

const apiApp = initializeApp(apiFirebaseConfig, "AigencyAPI");

export const apiDb = getFirestore(apiApp);

// Agent Firebase project (where themes are stored)
const agentFirebaseConfig = {
  apiKey: "AIzaSyBM2b1sIP57mNI_BH1sDgx5Kms1nGafmk8",
  authDomain: "aigency-agent.firebaseapp.com",
  projectId: "aigency-agent",
  storageBucket: "aigency-agent.appspot.com",
  messagingSenderId: "961209077929",
  appId: "1:961209077929:web:8fc486afeac69aa06ed9b8",
  measurementId: "G-VMHXGTPZV9",
  recaptchaSiteKey: "6LdGEAosAAAAAN0p42hg5pyUXF1xmsKEsFiikaqR",
};

const agentApp = initializeApp(agentFirebaseConfig, "aigency-agent");

export const agentStorage = getStorage(agentApp);

const landingFirebaseConfig = {
  apiKey: "AIzaSyAJSI6YD1PvYMh2-UomuRZ6Tx-9ZdCgQpI",
  authDomain: "aigency-homepage.firebaseapp.com",
  projectId: "aigency-homepage",
  storageBucket: "aigency-homepage.firebasestorage.app",
  messagingSenderId: "245747373437",
  appId: "1:245747373437:web:3f00168cd636f3bf51e814",
  measurementId: "G-39F0EV4XXV",
};

const landingApp = initializeApp(landingFirebaseConfig, "AigencyLanding");

export const landingDb =
  getEnvironment() === Environment.STAGING
    ? getFirestore(landingApp, Environment.STAGING)
    : getFirestore(landingApp);

if (getEnvironment() === Environment.LOCAL) {
  connectAuthEmulator(auth, "http://localhost:9099");
  connectFirestoreEmulator(db, "localhost", 8088);
  connectFirestoreEmulator(apiDb, "localhost", 8084);
  connectFirestoreEmulator(landingDb, "localhost", 8086);
  connectFunctionsEmulator(functions, "localhost", 5002);
  connectStorageEmulator(storage, "localhost", 9199);
}
